import styled from 'styled-components';
import background from '../../assets/home/background-bacve.jpg'
import { colors } from "../../utils/colors";

export const Background = styled.div`
    position: relative;
    width: 100%;
    min-height: 100vh;
    background: url(${background});
    background-repeat: no-repeat;
    background-size: cover;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: 100px 0;
`;

export const AllGroupWrapper = styled.div`
    width: 100%;
    margin: 100px auto 100px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
`;

export const GroupWrapper = styled.div`
    position: relative;    
    margin: 10px 20px;
`;

export const GroupTitle = styled.p`
    position: absolute;
    top: 20px;
    left: 30px;
    font-size: 22px;
    max-width: 190px;
    font-weight: bold;
    color: ${colors.DARK_BLUE};

    @media (max-width: 800px) {
        font-size: 16px;
    }

    @media (max-width: 600px) {
        font-size: 14px;
        max-width: 150px;
    }
`;

export const GroupDescription = styled.p`
    position: absolute;
    bottom: 30px;
    left: 30px;
    max-width: 200px;
    color: ${colors.CREAM};

    @media (max-width: 1200px) {
        display: none;
    }
`;